import axios from '@/libs/http'

//首单体验列表
export const getFirstOrderList = (wechatNumber, sex, status, pageNo, pageSize) => {
    return axios.request({
        url: '/s/k/kf/wechatRecordList',
        params: {
            wechatNumber,
            sex,
            status,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

//修改首单体验状态
export const updateFirstOrderStatus = (status, wechatId,) => {
    return axios.request({
        url: '/s/k/kf/updateWechatStatus',
        params: {
            status,
            wechatId,
        },
        method: 'get'
    })
}

// 店员首单体验列表
export const getFirstOrderListForClerk = (wechatNumber, status, pageNo, pageSize) => {
    return axios.request({
        url: '/s/c/clerk/wechatRecordList',
        params: {
            wechatNumber,
            status,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

// 店员修改首单体验状态
export const updateFirstOrderStatusForClerk = (status, wechatId,imageListStr) => {
    return axios.request({
        url: '/s/c/clerk/updateWechatStatus',
        params: {
            status,
            wechatId,
            imageListStr
        },
        method: 'get'
    })
}
